<h2 mat-dialog-title>Sök bland bokningar</h2>
<div mat-dialog-content class="content">
  <mat-form-field appearance="outline" class="full-width">
    <input matInput [formControl]="searchInput" />
  </mat-form-field>

  @if (showSpinner) {
    <div class="spinner">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  }

  @if (!showSpinner && !results && !termTooShort && !termNotFound) {
    <div class="helper">
      Sök på registrerings- eller bokningsnummer.
    </div>
  }
  @if (termTooShort) {
    <div class="helper">Minst 3 tecken krävs.</div>
  }
  @if (termNotFound) {
    <div class="helper">Inga träffar för "{{ termNotFound }}"</div>
  }

  @if (results?.length) {
    <div class="results">
      @for (r of results; track r) {
        <div class="result-row" (click)="select(r)">
          <div class="reg"><span>{{ r.registrationNumber || 'okänt' }}</span> <span>|</span> <span
          class="passengers"><mat-icon>person</mat-icon> <span>{{ r.qtyPersons || 0
        }}</span>st</span></div>
        <div class="dates">
          <span class="dep" [matTooltip]="formatDate(r.departureDate)">Avresa: {{ formatDate(r.departureDate) }}</span>
          <span class="arr" [matTooltip]="formatDate(r.arrivalDate)">Ankomst: {{ formatDate(r.arrivalDate) }}</span>
        </div>
      </div>
    }
  </div>
}
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="close()">Stäng</button>
</div>